<div class="flex flex-col h-full overflow-hidden bg-(--bg-workflow) relative">
  <header class="flex flex-col p-5">
    <app-workflow-header [labelAvatar]="labelAvatar" />
  </header>
  <div class="flex flex-col main-wrapper overflow-auto">
    <main class="h-full main-workflow px-6 pb-6">
      <router-outlet />
    </main>
  </div>
</div>
<app-mail-box />
